export const strings = {
  deleteBlogSucess: "Blog deleted successfully!",
  invalidBlogId: "Invalid blog ID — cannot delete.",
  noBlogIdSelected: "No blog ID selected for deletion.",
  failToDeleteBlog: "Failed to delete the blog.",
  noReportIdAvailableForDissmiss: "No report ID available for dismissal.",
  NoReportSelected: "No report selected.",
  reportDissmissSuccess: "Report dismissed successfully!",
  failToDissmissReport: "Failed to dismiss the report.",
  dismissReport: "Dismiss Report",
  deleteBlog: "Delete Blog",
  noBlogsAvailable: "No blogs available.",
  postdeletedSuccess: "Post deleted successfully!",
  invalidPostId: "Invalid post ID — cannot delete.",
  failToDeletePost: "Failed to delete the post.",
  noPostIdSelected: "No Post ID available for dismissal.",
  DeletePost: "Delete Post",
  invalidStoryId: "Invalid story ID — cannot delete.",
  noStoryIdAvailable: "No Story ID selected for deletion.",
  containtDeletedSuccessfully: "Content deleted successfully!",
  failToDeleteContaint: "Failed to delete the content",
  DeleteStory: "Delete Story",
  noContaintAvailableForStory: "No content available for this story.",
  userDeleteSuccess: "User deleted successfully!",
  categoryUpdateSuccess: "Category Update successfully!",
  categoryCreateSuccessfully: "Category Create successfully!",
  categorydeleteSuccessfully: "Category deleted successfully!",
  failToDeleteCategory: "Failed to delete category.",
  noStoryAvailble: "No stories available.",
};
